var map = {
	"./": [
		18305,
		9
	],
	"./__theme__": [
		37101,
		7
	],
	"./__theme__/": [
		37101,
		7
	],
	"./__theme__/index": [
		37101,
		7
	],
	"./__theme__/index.js": [
		37101,
		7
	],
	"./assets/locales": [
		76083,
		9
	],
	"./assets/locales/": [
		76083,
		9
	],
	"./assets/locales/en/auth": [
		25191,
		3,
		5191
	],
	"./assets/locales/en/auth.json": [
		25191,
		3,
		5191
	],
	"./assets/locales/en/configurationProject": [
		93561,
		3,
		3561
	],
	"./assets/locales/en/configurationProject.json": [
		93561,
		3,
		3561
	],
	"./assets/locales/en/project": [
		70675,
		3,
		675
	],
	"./assets/locales/en/project.json": [
		70675,
		3,
		675
	],
	"./assets/locales/en/projects": [
		7118,
		3,
		7118
	],
	"./assets/locales/en/projects.json": [
		7118,
		3,
		7118
	],
	"./assets/locales/en/root": [
		40387,
		3,
		387
	],
	"./assets/locales/en/root.json": [
		40387,
		3,
		387
	],
	"./assets/locales/index": [
		76083,
		9
	],
	"./assets/locales/index.js": [
		76083,
		9
	],
	"./assets/tutorialMarkDown.md": [
		59894,
		1,
		9894
	],
	"./index": [
		18305,
		9
	],
	"./index.js": [
		18305,
		9
	],
	"./modules/configurationProject": [
		27931,
		9,
		48,
		976,
		646,
		8167,
		7931
	],
	"./modules/configurationProject/": [
		27931,
		9,
		48,
		976,
		646,
		8167,
		7931
	],
	"./modules/configurationProject/actions/__tests__/configurationProjectActions.test": [
		40068,
		9,
		68
	],
	"./modules/configurationProject/actions/__tests__/configurationProjectActions.test.js": [
		40068,
		9,
		68
	],
	"./modules/configurationProject/actions/configurationProjectActions": [
		5434,
		9,
		5434
	],
	"./modules/configurationProject/actions/configurationProjectActions.js": [
		5434,
		9,
		5434
	],
	"./modules/configurationProject/components/ConfigStepPage": [
		50148,
		9,
		5173,
		2641,
		2659,
		2304,
		5340,
		5053,
		148
	],
	"./modules/configurationProject/components/ConfigStepPage.js": [
		50148,
		9,
		5173,
		2641,
		2659,
		2304,
		5340,
		5053,
		148
	],
	"./modules/configurationProject/components/ConfigurationProjectPage": [
		93304,
		9,
		48,
		976,
		646,
		3304
	],
	"./modules/configurationProject/components/ConfigurationProjectPage.js": [
		93304,
		9,
		48,
		976,
		646,
		3304
	],
	"./modules/configurationProject/components/DesignStepPage": [
		37222,
		9,
		7222
	],
	"./modules/configurationProject/components/DesignStepPage.js": [
		37222,
		9,
		7222
	],
	"./modules/configurationProject/components/ExportStepPage": [
		27307,
		9,
		5173,
		5340,
		5820,
		7307
	],
	"./modules/configurationProject/components/ExportStepPage.js": [
		27307,
		9,
		5173,
		5340,
		5820,
		7307
	],
	"./modules/configurationProject/components/FilesStepPage": [
		81308,
		9,
		5173,
		2641,
		2659,
		2304,
		5340,
		976,
		4582,
		1308
	],
	"./modules/configurationProject/components/FilesStepPage.js": [
		81308,
		9,
		5173,
		2641,
		2659,
		2304,
		5340,
		976,
		4582,
		1308
	],
	"./modules/configurationProject/components/GuideStepPage": [
		96921,
		9,
		5173,
		2641,
		2659,
		1175,
		7550,
		6921
	],
	"./modules/configurationProject/components/GuideStepPage.js": [
		96921,
		9,
		5173,
		2641,
		2659,
		1175,
		7550,
		6921
	],
	"./modules/configurationProject/components/LabelingStepPage": [
		29795,
		9,
		5173,
		2641,
		2659,
		2304,
		5340,
		5053,
		1372,
		6366,
		1876,
		9795,
		5723
	],
	"./modules/configurationProject/components/LabelingStepPage.js": [
		29795,
		9,
		5173,
		2641,
		2659,
		2304,
		5340,
		5053,
		1372,
		6366,
		1876,
		9795,
		5723
	],
	"./modules/configurationProject/components/PreviewStepPage": [
		17111,
		9,
		7111
	],
	"./modules/configurationProject/components/PreviewStepPage.js": [
		17111,
		9,
		7111
	],
	"./modules/configurationProject/components/__styles__/ConfigStepPage.styles": [
		4772,
		9,
		5173,
		2641,
		2659,
		2304,
		5340,
		5053,
		4772
	],
	"./modules/configurationProject/components/__styles__/ConfigStepPage.styles.js": [
		4772,
		9,
		5173,
		2641,
		2659,
		2304,
		5340,
		5053,
		4772
	],
	"./modules/configurationProject/components/__styles__/ConfigurationProjectPage.styles": [
		21940,
		9,
		48,
		976,
		646,
		7286
	],
	"./modules/configurationProject/components/__styles__/ConfigurationProjectPage.styles.js": [
		21940,
		9,
		48,
		976,
		646,
		7286
	],
	"./modules/configurationProject/components/__styles__/ExportStepPage.styles": [
		27321,
		9,
		5173,
		5340,
		1101
	],
	"./modules/configurationProject/components/__styles__/ExportStepPage.styles.js": [
		27321,
		9,
		5173,
		5340,
		1101
	],
	"./modules/configurationProject/components/__styles__/FilesStepPage.styles": [
		48153,
		9,
		5173,
		2641,
		2659,
		2304,
		5340,
		9606
	],
	"./modules/configurationProject/components/__styles__/FilesStepPage.styles.js": [
		48153,
		9,
		5173,
		2641,
		2659,
		2304,
		5340,
		9606
	],
	"./modules/configurationProject/components/__styles__/LabelingStepPage.styles": [
		11796,
		9,
		5173,
		5340,
		6366,
		4681
	],
	"./modules/configurationProject/components/__styles__/LabelingStepPage.styles.js": [
		11796,
		9,
		5173,
		5340,
		6366,
		4681
	],
	"./modules/configurationProject/components/__tests__/ConfigStepPage.test": [
		59425,
		9,
		8693,
		5173,
		9607,
		2641,
		2659,
		2304,
		5340,
		5053,
		9425
	],
	"./modules/configurationProject/components/__tests__/ConfigStepPage.test.js": [
		59425,
		9,
		8693,
		5173,
		9607,
		2641,
		2659,
		2304,
		5340,
		5053,
		9425
	],
	"./modules/configurationProject/components/__tests__/ConfigurationProjectPage.test": [
		4498,
		9,
		8693,
		9607,
		48,
		976,
		646,
		4498
	],
	"./modules/configurationProject/components/__tests__/ConfigurationProjectPage.test.js": [
		4498,
		9,
		8693,
		9607,
		48,
		976,
		646,
		4498
	],
	"./modules/configurationProject/components/__tests__/DesignStepPage.test": [
		16828,
		9,
		8693,
		9607,
		6828
	],
	"./modules/configurationProject/components/__tests__/DesignStepPage.test.js": [
		16828,
		9,
		8693,
		9607,
		6828
	],
	"./modules/configurationProject/components/__tests__/ExportStepPage.test": [
		82556,
		9,
		8693,
		5173,
		9607,
		5340,
		5820,
		2556
	],
	"./modules/configurationProject/components/__tests__/ExportStepPage.test.js": [
		82556,
		9,
		8693,
		5173,
		9607,
		5340,
		5820,
		2556
	],
	"./modules/configurationProject/components/__tests__/FilesStepPage.test": [
		61886,
		9,
		8693,
		5173,
		9607,
		2641,
		2659,
		2304,
		5340,
		976,
		4582,
		1886
	],
	"./modules/configurationProject/components/__tests__/FilesStepPage.test.js": [
		61886,
		9,
		8693,
		5173,
		9607,
		2641,
		2659,
		2304,
		5340,
		976,
		4582,
		1886
	],
	"./modules/configurationProject/components/__tests__/GuideStepPage.test": [
		3835,
		9,
		8693,
		5173,
		9607,
		2641,
		2659,
		1175,
		7550,
		3835
	],
	"./modules/configurationProject/components/__tests__/GuideStepPage.test.js": [
		3835,
		9,
		8693,
		5173,
		9607,
		2641,
		2659,
		1175,
		7550,
		3835
	],
	"./modules/configurationProject/components/__tests__/LabelingStepPage.test": [
		18023,
		9,
		8693,
		5173,
		9607,
		2641,
		2659,
		2304,
		5340,
		5053,
		1372,
		6366,
		1876,
		9795,
		1139
	],
	"./modules/configurationProject/components/__tests__/LabelingStepPage.test.js": [
		18023,
		9,
		8693,
		5173,
		9607,
		2641,
		2659,
		2304,
		5340,
		5053,
		1372,
		6366,
		1876,
		9795,
		1139
	],
	"./modules/configurationProject/components/__tests__/PreviewStepPage.test": [
		2349,
		9,
		8693,
		9607,
		2349
	],
	"./modules/configurationProject/components/__tests__/PreviewStepPage.test.js": [
		2349,
		9,
		8693,
		9607,
		2349
	],
	"./modules/configurationProject/components/__tests__/__snapshots__/ConfigStepPage.test.js.snap": [
		48397,
		1,
		8397
	],
	"./modules/configurationProject/components/__tests__/__snapshots__/ConfigurationProjectPage.test.js.snap": [
		59686,
		1,
		9686
	],
	"./modules/configurationProject/components/__tests__/__snapshots__/DesignStepPage.test.js.snap": [
		66092,
		1,
		4466
	],
	"./modules/configurationProject/components/__tests__/__snapshots__/ExportStepPage.test.js.snap": [
		29786,
		1,
		9786
	],
	"./modules/configurationProject/components/__tests__/__snapshots__/FilesStepPage.test.js.snap": [
		24254,
		1,
		4254
	],
	"./modules/configurationProject/components/__tests__/__snapshots__/GuideStepPage.test.js.snap": [
		25324,
		1,
		5324
	],
	"./modules/configurationProject/components/__tests__/__snapshots__/LabelingStepPage.test.js.snap": [
		5402,
		1,
		5402
	],
	"./modules/configurationProject/components/__tests__/__snapshots__/PreviewStepPage.test.js.snap": [
		60477,
		1,
		477
	],
	"./modules/configurationProject/index": [
		27931,
		9,
		48,
		976,
		646,
		8167,
		7931
	],
	"./modules/configurationProject/index.js": [
		27931,
		9,
		48,
		976,
		646,
		8167,
		7931
	],
	"./modules/configurationProject/reducers/__tests__/configurationProjectReducer.test": [
		87868,
		9,
		7868
	],
	"./modules/configurationProject/reducers/__tests__/configurationProjectReducer.test.js": [
		87868,
		9,
		7868
	],
	"./modules/configurationProject/reducers/configurationProjectReducer": [
		24468,
		9,
		4468
	],
	"./modules/configurationProject/reducers/configurationProjectReducer.js": [
		24468,
		9,
		4468
	],
	"./modules/configurationProject/sagas/__tests__/configurationProjectSagas.test": [
		38952,
		9,
		2843,
		8167,
		5146
	],
	"./modules/configurationProject/sagas/__tests__/configurationProjectSagas.test.js": [
		38952,
		9,
		2843,
		8167,
		5146
	],
	"./modules/configurationProject/sagas/configurationProjectSagas": [
		78167,
		9,
		8167
	],
	"./modules/configurationProject/sagas/configurationProjectSagas.js": [
		78167,
		9,
		8167
	],
	"./modules/configurationProject/selectors/__tests__/configurationProjectSelectors.test": [
		83499,
		9,
		3499
	],
	"./modules/configurationProject/selectors/__tests__/configurationProjectSelectors.test.js": [
		83499,
		9,
		3499
	],
	"./modules/configurationProject/selectors/configurationProjectSelectors": [
		61781,
		9
	],
	"./modules/configurationProject/selectors/configurationProjectSelectors.js": [
		61781,
		9
	],
	"./modules/configurationProject/services/__tests__/configurationProjectServices.test": [
		70715,
		9,
		715
	],
	"./modules/configurationProject/services/__tests__/configurationProjectServices.test.js": [
		70715,
		9,
		715
	],
	"./modules/configurationProject/services/configurationProjectServices": [
		22264,
		9,
		2264
	],
	"./modules/configurationProject/services/configurationProjectServices.js": [
		22264,
		9,
		2264
	],
	"./modules/project": [
		97178,
		9,
		5173,
		2641,
		2659,
		2304,
		5340,
		1504,
		5053,
		1372,
		1175,
		8621,
		4229,
		9432,
		516,
		2850,
		4398,
		7178
	],
	"./modules/project/": [
		97178,
		9,
		5173,
		2641,
		2659,
		2304,
		5340,
		1504,
		5053,
		1372,
		1175,
		8621,
		4229,
		9432,
		516,
		2850,
		4398,
		7178
	],
	"./modules/project/actions/__tests__/annotationActions.test": [
		8554,
		9,
		8554
	],
	"./modules/project/actions/__tests__/annotationActions.test.js": [
		8554,
		9,
		8554
	],
	"./modules/project/actions/__tests__/filterActions.test": [
		73639,
		9,
		3639
	],
	"./modules/project/actions/__tests__/filterActions.test.js": [
		73639,
		9,
		3639
	],
	"./modules/project/actions/__tests__/projectActions.test": [
		52887,
		9,
		2887
	],
	"./modules/project/actions/__tests__/projectActions.test.js": [
		52887,
		9,
		2887
	],
	"./modules/project/actions/annotationActions": [
		87209,
		9,
		7209
	],
	"./modules/project/actions/annotationActions.js": [
		87209,
		9,
		7209
	],
	"./modules/project/actions/filterActions": [
		9701,
		9,
		9701
	],
	"./modules/project/actions/filterActions.js": [
		9701,
		9,
		9701
	],
	"./modules/project/actions/projectActions": [
		17882,
		9,
		7882
	],
	"./modules/project/actions/projectActions.js": [
		17882,
		9,
		7882
	],
	"./modules/project/components/common/ActionBar": [
		63207,
		9,
		5173,
		2304,
		8511,
		97
	],
	"./modules/project/components/common/ActionBar.js": [
		63207,
		9,
		5173,
		2304,
		8511,
		97
	],
	"./modules/project/components/common/AnnotationItemWrapper": [
		68699,
		9,
		8703,
		3369,
		8363,
		1151,
		6669,
		8216
	],
	"./modules/project/components/common/AnnotationItemWrapper.js": [
		68699,
		9,
		8703,
		3369,
		8363,
		1151,
		6669,
		8216
	],
	"./modules/project/components/common/AnnotatorsContainer": [
		19315,
		9,
		9315
	],
	"./modules/project/components/common/AnnotatorsContainer.js": [
		19315,
		9,
		9315
	],
	"./modules/project/components/common/AudioItem": [
		36647,
		9,
		6647
	],
	"./modules/project/components/common/AudioItem.js": [
		36647,
		9,
		6647
	],
	"./modules/project/components/common/CheckLabelList": [
		50105,
		9,
		5173,
		2641,
		2659,
		1504,
		5648,
		4715
	],
	"./modules/project/components/common/CheckLabelList.js": [
		50105,
		9,
		5173,
		2641,
		2659,
		1504,
		5648,
		4715
	],
	"./modules/project/components/common/FilterForm": [
		72850,
		9,
		5173,
		2641,
		2659,
		2304,
		5340,
		1504,
		5053,
		1372,
		8621,
		4229,
		2850,
		3293
	],
	"./modules/project/components/common/FilterForm.js": [
		72850,
		9,
		5173,
		2641,
		2659,
		2304,
		5340,
		1504,
		5053,
		1372,
		8621,
		4229,
		2850,
		3293
	],
	"./modules/project/components/common/FourPointsIcon": [
		11282,
		9,
		1282
	],
	"./modules/project/components/common/FourPointsIcon.js": [
		11282,
		9,
		1282
	],
	"./modules/project/components/common/GuideModal": [
		80924,
		9,
		5173,
		2641,
		2659,
		1504,
		1175,
		7900
	],
	"./modules/project/components/common/GuideModal.js": [
		80924,
		9,
		5173,
		2641,
		2659,
		1504,
		1175,
		7900
	],
	"./modules/project/components/common/HeaderItemContainer": [
		33347,
		9,
		3347
	],
	"./modules/project/components/common/HeaderItemContainer.js": [
		33347,
		9,
		3347
	],
	"./modules/project/components/common/HtmlItem": [
		21175,
		9,
		8703,
		4387
	],
	"./modules/project/components/common/HtmlItem.js": [
		21175,
		9,
		8703,
		4387
	],
	"./modules/project/components/common/ImageMarker": [
		22947,
		9,
		144,
		2947,
		6404
	],
	"./modules/project/components/common/ImageMarker.js": [
		22947,
		9,
		144,
		2947,
		6404
	],
	"./modules/project/components/common/JSONPreview": [
		70206,
		9,
		206
	],
	"./modules/project/components/common/JSONPreview.js": [
		70206,
		9,
		206
	],
	"./modules/project/components/common/LogsContainer": [
		38207,
		9,
		5173,
		2641,
		5340,
		3369,
		6554,
		8207,
		8662
	],
	"./modules/project/components/common/LogsContainer.js": [
		38207,
		9,
		5173,
		2641,
		5340,
		3369,
		6554,
		8207,
		8662
	],
	"./modules/project/components/common/NerContainer": [
		11151,
		9,
		3369,
		1151,
		4007
	],
	"./modules/project/components/common/NerContainer.js": [
		11151,
		9,
		3369,
		1151,
		4007
	],
	"./modules/project/components/common/NerMark": [
		592,
		9,
		592
	],
	"./modules/project/components/common/NerMark.js": [
		592,
		9,
		592
	],
	"./modules/project/components/common/NerMarks": [
		9379,
		9,
		9379
	],
	"./modules/project/components/common/NerMarks.js": [
		9379,
		9,
		9379
	],
	"./modules/project/components/common/PolygonIcon": [
		73057,
		9,
		3057
	],
	"./modules/project/components/common/PolygonIcon.js": [
		73057,
		9,
		3057
	],
	"./modules/project/components/common/RelationPath": [
		63913,
		9,
		3369,
		5834
	],
	"./modules/project/components/common/RelationPath.js": [
		63913,
		9,
		3369,
		5834
	],
	"./modules/project/components/common/SettingsDrawer": [
		54874,
		9,
		5173,
		2304,
		5340,
		8102,
		9838,
		5084
	],
	"./modules/project/components/common/SettingsDrawer.js": [
		54874,
		9,
		5173,
		2304,
		5340,
		8102,
		9838,
		5084
	],
	"./modules/project/components/common/TagsOutlinedIcon": [
		34669,
		9,
		4669
	],
	"./modules/project/components/common/TagsOutlinedIcon.js": [
		34669,
		9,
		4669
	],
	"./modules/project/components/common/TextAnnotationsContainer": [
		77953,
		9,
		2641,
		2659,
		1504,
		4908
	],
	"./modules/project/components/common/TextAnnotationsContainer.js": [
		77953,
		9,
		2641,
		2659,
		1504,
		4908
	],
	"./modules/project/components/common/TextItemContainer": [
		93398,
		9,
		8703,
		3398
	],
	"./modules/project/components/common/TextItemContainer.js": [
		93398,
		9,
		8703,
		3398
	],
	"./modules/project/components/common/TwoPointsIcon": [
		13542,
		9,
		3542
	],
	"./modules/project/components/common/TwoPointsIcon.js": [
		13542,
		9,
		3542
	],
	"./modules/project/components/common/VideoItem": [
		39156,
		9,
		9156
	],
	"./modules/project/components/common/VideoItem.js": [
		39156,
		9,
		9156
	],
	"./modules/project/components/common/ZoneTools": [
		36585,
		9,
		2641,
		2659,
		1504,
		5307
	],
	"./modules/project/components/common/ZoneTools.js": [
		36585,
		9,
		2641,
		2659,
		1504,
		5307
	],
	"./modules/project/components/common/__styles__/ActionBar.styles": [
		20263,
		9,
		2304,
		8511,
		6952
	],
	"./modules/project/components/common/__styles__/ActionBar.styles.js": [
		20263,
		9,
		2304,
		8511,
		6952
	],
	"./modules/project/components/common/__styles__/AnnotatorsContainer.styles": [
		52486,
		9,
		2486
	],
	"./modules/project/components/common/__styles__/AnnotatorsContainer.styles.js": [
		52486,
		9,
		2486
	],
	"./modules/project/components/common/__styles__/AudioItem.styles": [
		57616,
		9,
		7616
	],
	"./modules/project/components/common/__styles__/AudioItem.styles.js": [
		57616,
		9,
		7616
	],
	"./modules/project/components/common/__styles__/CheckLabelList.styles": [
		44311,
		9,
		5173,
		2641,
		2659,
		1504,
		3433
	],
	"./modules/project/components/common/__styles__/CheckLabelList.styles.js": [
		44311,
		9,
		5173,
		2641,
		2659,
		1504,
		3433
	],
	"./modules/project/components/common/__styles__/FilterForm.styles": [
		58649,
		9,
		5173,
		2641,
		2659,
		5340,
		1504,
		4627
	],
	"./modules/project/components/common/__styles__/FilterForm.styles.js": [
		58649,
		9,
		5173,
		2641,
		2659,
		5340,
		1504,
		4627
	],
	"./modules/project/components/common/__styles__/GuideModal.styles": [
		60270,
		9,
		5173,
		2641,
		2659,
		1504,
		1741
	],
	"./modules/project/components/common/__styles__/GuideModal.styles.js": [
		60270,
		9,
		5173,
		2641,
		2659,
		1504,
		1741
	],
	"./modules/project/components/common/__styles__/HeaderItemContainer.styles": [
		73394,
		9,
		3394
	],
	"./modules/project/components/common/__styles__/HeaderItemContainer.styles.js": [
		73394,
		9,
		3394
	],
	"./modules/project/components/common/__styles__/HtmlItem.styles": [
		91154,
		9,
		1154
	],
	"./modules/project/components/common/__styles__/HtmlItem.styles.js": [
		91154,
		9,
		1154
	],
	"./modules/project/components/common/__styles__/ImageMarker.styles": [
		57837,
		9,
		144,
		3697
	],
	"./modules/project/components/common/__styles__/ImageMarker.styles.js": [
		57837,
		9,
		144,
		3697
	],
	"./modules/project/components/common/__styles__/JSONPreview.styles": [
		48524,
		9,
		8524
	],
	"./modules/project/components/common/__styles__/JSONPreview.styles.js": [
		48524,
		9,
		8524
	],
	"./modules/project/components/common/__styles__/LogsContainer.styles": [
		7047,
		9,
		5173,
		5340,
		1005
	],
	"./modules/project/components/common/__styles__/LogsContainer.styles.js": [
		7047,
		9,
		5173,
		5340,
		1005
	],
	"./modules/project/components/common/__styles__/NerContainer.styles": [
		22718,
		9,
		2718
	],
	"./modules/project/components/common/__styles__/NerContainer.styles.js": [
		22718,
		9,
		2718
	],
	"./modules/project/components/common/__styles__/RelationPath.styles": [
		19370,
		9,
		9370
	],
	"./modules/project/components/common/__styles__/RelationPath.styles.js": [
		19370,
		9,
		9370
	],
	"./modules/project/components/common/__styles__/SettingsDrawer.styles": [
		83619,
		9,
		5173,
		2304,
		8102,
		638
	],
	"./modules/project/components/common/__styles__/SettingsDrawer.styles.js": [
		83619,
		9,
		5173,
		2304,
		8102,
		638
	],
	"./modules/project/components/common/__styles__/TextAnnotationsContainer.styles": [
		81087,
		9,
		2641,
		2659,
		1504,
		2611
	],
	"./modules/project/components/common/__styles__/TextAnnotationsContainer.styles.js": [
		81087,
		9,
		2641,
		2659,
		1504,
		2611
	],
	"./modules/project/components/common/__styles__/TextItemContainer.styles": [
		76169,
		9,
		6169
	],
	"./modules/project/components/common/__styles__/TextItemContainer.styles.js": [
		76169,
		9,
		6169
	],
	"./modules/project/components/common/__styles__/VideoItem.styles": [
		60083,
		9,
		83
	],
	"./modules/project/components/common/__styles__/VideoItem.styles.js": [
		60083,
		9,
		83
	],
	"./modules/project/components/common/__styles__/ZoneTools.styles": [
		56278,
		9,
		6278
	],
	"./modules/project/components/common/__styles__/ZoneTools.styles.js": [
		56278,
		9,
		6278
	],
	"./modules/project/components/common/__tests__/AnnotationItemWrapper.test": [
		6233,
		9,
		8693,
		9607,
		8703,
		3369,
		8363,
		3151,
		1151,
		6669,
		6233
	],
	"./modules/project/components/common/__tests__/AnnotationItemWrapper.test.js": [
		6233,
		9,
		8693,
		9607,
		8703,
		3369,
		8363,
		3151,
		1151,
		6669,
		6233
	],
	"./modules/project/components/common/__tests__/AnnotatorsContainer.test": [
		54979,
		9,
		8693,
		9607,
		4979
	],
	"./modules/project/components/common/__tests__/AnnotatorsContainer.test.js": [
		54979,
		9,
		8693,
		9607,
		4979
	],
	"./modules/project/components/common/__tests__/AudioItem.test": [
		59530,
		9,
		8693,
		9607,
		9530
	],
	"./modules/project/components/common/__tests__/AudioItem.test.js": [
		59530,
		9,
		8693,
		9607,
		9530
	],
	"./modules/project/components/common/__tests__/CheckLabelList.test": [
		19152,
		9,
		8693,
		5173,
		9607,
		2641,
		2659,
		1504,
		5648,
		2973
	],
	"./modules/project/components/common/__tests__/CheckLabelList.test.js": [
		19152,
		9,
		8693,
		5173,
		9607,
		2641,
		2659,
		1504,
		5648,
		2973
	],
	"./modules/project/components/common/__tests__/GuideModal.test": [
		18841,
		9,
		8693,
		5173,
		9607,
		2641,
		2659,
		1504,
		1175,
		8559
	],
	"./modules/project/components/common/__tests__/GuideModal.test.js": [
		18841,
		9,
		8693,
		5173,
		9607,
		2641,
		2659,
		1504,
		1175,
		8559
	],
	"./modules/project/components/common/__tests__/HeaderItemContainer.test": [
		53293,
		9,
		8693,
		9607,
		3532
	],
	"./modules/project/components/common/__tests__/HeaderItemContainer.test.js": [
		53293,
		9,
		8693,
		9607,
		3532
	],
	"./modules/project/components/common/__tests__/HtmlItem.test": [
		44653,
		9,
		8693,
		9607,
		8703,
		4653
	],
	"./modules/project/components/common/__tests__/HtmlItem.test.js": [
		44653,
		9,
		8693,
		9607,
		8703,
		4653
	],
	"./modules/project/components/common/__tests__/ImageMarker.test": [
		72616,
		9,
		8693,
		9607,
		144,
		2947,
		8189
	],
	"./modules/project/components/common/__tests__/ImageMarker.test.js": [
		72616,
		9,
		8693,
		9607,
		144,
		2947,
		8189
	],
	"./modules/project/components/common/__tests__/JSONPreview.test": [
		46610,
		9,
		8693,
		9607,
		6610
	],
	"./modules/project/components/common/__tests__/JSONPreview.test.js": [
		46610,
		9,
		8693,
		9607,
		6610
	],
	"./modules/project/components/common/__tests__/NerContainer.test": [
		74715,
		9,
		8693,
		9607,
		3369,
		1151,
		201
	],
	"./modules/project/components/common/__tests__/NerContainer.test.js": [
		74715,
		9,
		8693,
		9607,
		3369,
		1151,
		201
	],
	"./modules/project/components/common/__tests__/RelationPath.test": [
		98430,
		9,
		8693,
		9607,
		3369,
		8430
	],
	"./modules/project/components/common/__tests__/RelationPath.test.js": [
		98430,
		9,
		8693,
		9607,
		3369,
		8430
	],
	"./modules/project/components/common/__tests__/SettingsDrawer.test": [
		58645,
		9,
		8693,
		5173,
		9607,
		2304,
		5340,
		8102,
		9838,
		3719
	],
	"./modules/project/components/common/__tests__/SettingsDrawer.test.js": [
		58645,
		9,
		8693,
		5173,
		9607,
		2304,
		5340,
		8102,
		9838,
		3719
	],
	"./modules/project/components/common/__tests__/TextAnnotationsContainer.test": [
		37558,
		9,
		8693,
		9607,
		2641,
		2659,
		1504,
		6432
	],
	"./modules/project/components/common/__tests__/TextAnnotationsContainer.test.js": [
		37558,
		9,
		8693,
		9607,
		2641,
		2659,
		1504,
		6432
	],
	"./modules/project/components/common/__tests__/TextItemContainer.test": [
		80583,
		9,
		8693,
		9607,
		8703,
		583
	],
	"./modules/project/components/common/__tests__/TextItemContainer.test.js": [
		80583,
		9,
		8693,
		9607,
		8703,
		583
	],
	"./modules/project/components/common/__tests__/VideoItem.test": [
		67697,
		9,
		8693,
		9607,
		7697
	],
	"./modules/project/components/common/__tests__/VideoItem.test.js": [
		67697,
		9,
		8693,
		9607,
		7697
	],
	"./modules/project/components/common/__tests__/__snapshots__/AnnotatorsContainer.test.js.snap": [
		66478,
		1,
		6478
	],
	"./modules/project/components/common/__tests__/__snapshots__/CheckLabelList.test.js.snap": [
		68556,
		1,
		8556
	],
	"./modules/project/components/common/__tests__/__snapshots__/GuideModal.test.js.snap": [
		99626,
		1,
		9626
	],
	"./modules/project/components/common/__tests__/__snapshots__/HeaderItemContainer.test.js.snap": [
		16040,
		1,
		6040
	],
	"./modules/project/components/common/__tests__/__snapshots__/HtmlItem.test.js.snap": [
		18672,
		1,
		8672
	],
	"./modules/project/components/common/__tests__/__snapshots__/ImageMarker.test.js.snap": [
		84785,
		1,
		4785
	],
	"./modules/project/components/common/__tests__/__snapshots__/JSONPreview.test.js.snap": [
		8448,
		1,
		8448
	],
	"./modules/project/components/common/__tests__/__snapshots__/NerContainer.test.js.snap": [
		32538,
		1,
		2538
	],
	"./modules/project/components/common/__tests__/__snapshots__/RelationPath.test.js.snap": [
		39904,
		1,
		9904
	],
	"./modules/project/components/common/__tests__/__snapshots__/SettingsDrawer.test.js.snap": [
		2750,
		1,
		2750
	],
	"./modules/project/components/common/__tests__/__snapshots__/TextAnnotationsContainer.test.js.snap": [
		84422,
		1,
		4422
	],
	"./modules/project/components/common/__tests__/__snapshots__/TextItemContainer.test.js.snap": [
		77441,
		1,
		7441
	],
	"./modules/project/components/common/__tests__/__snapshots__/formFactory.test.js.snap": [
		61185,
		1,
		1185
	],
	"./modules/project/components/common/__tests__/formFactory.test": [
		89537,
		9,
		8693,
		5173,
		9607,
		2641,
		2659,
		2304,
		5340,
		5053,
		1372,
		9537
	],
	"./modules/project/components/common/__tests__/formFactory.test.js": [
		89537,
		9,
		8693,
		5173,
		9607,
		2641,
		2659,
		2304,
		5340,
		5053,
		1372,
		9537
	],
	"./modules/project/components/common/formFactory": [
		49362,
		9,
		5173,
		2641,
		2659,
		2304,
		5340,
		5053,
		1372,
		9362
	],
	"./modules/project/components/common/formFactory.js": [
		49362,
		9,
		5173,
		2641,
		2659,
		2304,
		5340,
		5053,
		1372,
		9362
	],
	"./modules/project/components/common/image/AnchorPoint": [
		74952,
		9,
		8363,
		9681
	],
	"./modules/project/components/common/image/AnchorPoint.js": [
		74952,
		9,
		8363,
		9681
	],
	"./modules/project/components/common/image/ImageContainer": [
		86669,
		9,
		8363,
		6669,
		3790
	],
	"./modules/project/components/common/image/ImageContainer.js": [
		86669,
		9,
		8363,
		6669,
		3790
	],
	"./modules/project/components/common/image/ZoneMarker": [
		282,
		9,
		8363,
		8950
	],
	"./modules/project/components/common/image/ZoneMarker.js": [
		282,
		9,
		8363,
		8950
	],
	"./modules/project/components/common/image/__styles__/ImageContainer.styles": [
		73123,
		9,
		3123
	],
	"./modules/project/components/common/image/__styles__/ImageContainer.styles.js": [
		73123,
		9,
		3123
	],
	"./modules/project/components/pages/AnnotationPage": [
		63756,
		9,
		5173,
		2641,
		2659,
		2304,
		5340,
		1504,
		8703,
		3369,
		8363,
		6554,
		8102,
		8511,
		9838,
		5648,
		867,
		1151,
		8207,
		6669,
		9994,
		8394
	],
	"./modules/project/components/pages/AnnotationPage.js": [
		63756,
		9,
		5173,
		2641,
		2659,
		2304,
		5340,
		1504,
		8703,
		3369,
		8363,
		6554,
		8102,
		8511,
		9838,
		5648,
		867,
		1151,
		8207,
		6669,
		9994,
		8394
	],
	"./modules/project/components/pages/HomeProjectPage": [
		35745,
		9,
		5173,
		2641,
		2659,
		2304,
		5340,
		8703,
		3369,
		1819,
		48,
		6554,
		7442,
		8207,
		5745,
		7563
	],
	"./modules/project/components/pages/HomeProjectPage.js": [
		35745,
		9,
		5173,
		2641,
		2659,
		2304,
		5340,
		8703,
		3369,
		1819,
		48,
		6554,
		7442,
		8207,
		5745,
		7563
	],
	"./modules/project/components/pages/ProjectPage": [
		60286,
		9,
		5173,
		2641,
		2659,
		2304,
		5340,
		1504,
		5053,
		1372,
		1175,
		8621,
		4229,
		2850,
		9647
	],
	"./modules/project/components/pages/ProjectPage.js": [
		60286,
		9,
		5173,
		2641,
		2659,
		2304,
		5340,
		1504,
		5053,
		1372,
		1175,
		8621,
		4229,
		2850,
		9647
	],
	"./modules/project/components/pages/__styles__/AnnotationPage.styles": [
		53200,
		9,
		3200
	],
	"./modules/project/components/pages/__styles__/AnnotationPage.styles.js": [
		53200,
		9,
		3200
	],
	"./modules/project/components/pages/__styles__/HomeProjectPage.styles": [
		13664,
		9,
		2641,
		2659,
		2304,
		1819,
		9747
	],
	"./modules/project/components/pages/__styles__/HomeProjectPage.styles.js": [
		13664,
		9,
		2641,
		2659,
		2304,
		1819,
		9747
	],
	"./modules/project/components/pages/__styles__/ProjectPage.styles": [
		47325,
		9,
		7325
	],
	"./modules/project/components/pages/__styles__/ProjectPage.styles.js": [
		47325,
		9,
		7325
	],
	"./modules/project/components/pages/__tests__/AnnotationPage.test": [
		2097,
		9,
		8693,
		5173,
		9607,
		2641,
		2659,
		2304,
		5340,
		1504,
		8703,
		3369,
		8363,
		6554,
		8102,
		8511,
		9838,
		5648,
		867,
		1151,
		8207,
		6669,
		9994,
		2097
	],
	"./modules/project/components/pages/__tests__/AnnotationPage.test.js": [
		2097,
		9,
		8693,
		5173,
		9607,
		2641,
		2659,
		2304,
		5340,
		1504,
		8703,
		3369,
		8363,
		6554,
		8102,
		8511,
		9838,
		5648,
		867,
		1151,
		8207,
		6669,
		9994,
		2097
	],
	"./modules/project/components/pages/__tests__/HomeProjectPage.test": [
		27464,
		9,
		8693,
		5173,
		9607,
		2641,
		2659,
		2304,
		5340,
		8703,
		3369,
		1819,
		48,
		6554,
		7442,
		8207,
		5745,
		7464
	],
	"./modules/project/components/pages/__tests__/HomeProjectPage.test.js": [
		27464,
		9,
		8693,
		5173,
		9607,
		2641,
		2659,
		2304,
		5340,
		8703,
		3369,
		1819,
		48,
		6554,
		7442,
		8207,
		5745,
		7464
	],
	"./modules/project/components/pages/__tests__/ProjectPage.test": [
		50092,
		9,
		8693,
		5173,
		9607,
		2641,
		2659,
		2304,
		5340,
		1504,
		5053,
		1372,
		1175,
		8621,
		4229,
		2850,
		1749
	],
	"./modules/project/components/pages/__tests__/ProjectPage.test.js": [
		50092,
		9,
		8693,
		5173,
		9607,
		2641,
		2659,
		2304,
		5340,
		1504,
		5053,
		1372,
		1175,
		8621,
		4229,
		2850,
		1749
	],
	"./modules/project/components/pages/__tests__/__snapshots__/AnnotationPage.test.js.snap": [
		62471,
		1,
		2471
	],
	"./modules/project/components/pages/__tests__/__snapshots__/HomeProjectPage.test.js.snap": [
		94409,
		1,
		4409
	],
	"./modules/project/components/pages/__tests__/__snapshots__/ProjectPage.test.js.snap": [
		50819,
		1,
		819
	],
	"./modules/project/hooks/__tests__/useNerDimensions.test": [
		4320,
		9,
		8693,
		327,
		4320
	],
	"./modules/project/hooks/__tests__/useNerDimensions.test.js": [
		4320,
		9,
		8693,
		327,
		4320
	],
	"./modules/project/hooks/useNerDimensions": [
		17460,
		9,
		7460
	],
	"./modules/project/hooks/useNerDimensions.js": [
		17460,
		9,
		7460
	],
	"./modules/project/index": [
		97178,
		9,
		5173,
		2641,
		2659,
		2304,
		5340,
		1504,
		5053,
		1372,
		1175,
		8621,
		4229,
		9432,
		516,
		2850,
		4398,
		7178
	],
	"./modules/project/index.js": [
		97178,
		9,
		5173,
		2641,
		2659,
		2304,
		5340,
		1504,
		5053,
		1372,
		1175,
		8621,
		4229,
		9432,
		516,
		2850,
		4398,
		7178
	],
	"./modules/project/reducers/__tests__/projectReducer.test": [
		4602,
		9,
		9432,
		4602
	],
	"./modules/project/reducers/__tests__/projectReducer.test.js": [
		4602,
		9,
		9432,
		4602
	],
	"./modules/project/reducers/projectReducer": [
		79432,
		9,
		9432
	],
	"./modules/project/reducers/projectReducer.js": [
		79432,
		9,
		9432
	],
	"./modules/project/sagas/__tests__/annotationSagas.test": [
		71843,
		9,
		2843,
		9432,
		516,
		6939
	],
	"./modules/project/sagas/__tests__/annotationSagas.test.js": [
		71843,
		9,
		2843,
		9432,
		516,
		6939
	],
	"./modules/project/sagas/__tests__/filterSagas.test": [
		7653,
		9,
		2843,
		9694
	],
	"./modules/project/sagas/__tests__/filterSagas.test.js": [
		7653,
		9,
		2843,
		9694
	],
	"./modules/project/sagas/__tests__/projectSagas.test": [
		14682,
		9,
		2843,
		9432,
		516,
		4398,
		3901
	],
	"./modules/project/sagas/__tests__/projectSagas.test.js": [
		14682,
		9,
		2843,
		9432,
		516,
		4398,
		3901
	],
	"./modules/project/sagas/annotationSagas": [
		30516,
		9,
		9432,
		516
	],
	"./modules/project/sagas/annotationSagas.js": [
		30516,
		9,
		9432,
		516
	],
	"./modules/project/sagas/filterSagas": [
		8067,
		9,
		8067
	],
	"./modules/project/sagas/filterSagas.js": [
		8067,
		9,
		8067
	],
	"./modules/project/sagas/projectSagas": [
		14398,
		9,
		9432,
		516,
		4398
	],
	"./modules/project/sagas/projectSagas.js": [
		14398,
		9,
		9432,
		516,
		4398
	],
	"./modules/project/selectors/__tests__/annotationSelectors.test": [
		51184,
		9,
		1184
	],
	"./modules/project/selectors/__tests__/annotationSelectors.test.js": [
		51184,
		9,
		1184
	],
	"./modules/project/selectors/__tests__/projectSelectors.test": [
		11575,
		9,
		1575
	],
	"./modules/project/selectors/__tests__/projectSelectors.test.js": [
		11575,
		9,
		1575
	],
	"./modules/project/selectors/annotationSelectors": [
		43445,
		9,
		3445
	],
	"./modules/project/selectors/annotationSelectors.js": [
		43445,
		9,
		3445
	],
	"./modules/project/selectors/projectSelectors": [
		39834,
		9
	],
	"./modules/project/selectors/projectSelectors.js": [
		39834,
		9
	],
	"./modules/project/services/__tests__/annotationServices.test": [
		24138,
		9,
		4138
	],
	"./modules/project/services/__tests__/annotationServices.test.js": [
		24138,
		9,
		4138
	],
	"./modules/project/services/__tests__/nerAnnotationServices.test": [
		60506,
		9,
		506
	],
	"./modules/project/services/__tests__/nerAnnotationServices.test.js": [
		60506,
		9,
		506
	],
	"./modules/project/services/__tests__/projectServices.test": [
		65070,
		9,
		5070
	],
	"./modules/project/services/__tests__/projectServices.test.js": [
		65070,
		9,
		5070
	],
	"./modules/project/services/annotationServices": [
		8686,
		9,
		8686
	],
	"./modules/project/services/annotationServices.js": [
		8686,
		9,
		8686
	],
	"./modules/project/services/nerAnnotationServices": [
		95229,
		9,
		5229
	],
	"./modules/project/services/nerAnnotationServices.js": [
		95229,
		9,
		5229
	],
	"./modules/project/services/projectServices": [
		77148,
		9,
		7148
	],
	"./modules/project/services/projectServices.js": [
		77148,
		9,
		7148
	],
	"./modules/project/utils/__tests__/labelListUtils.test": [
		65444,
		9,
		5444
	],
	"./modules/project/utils/__tests__/labelListUtils.test.js": [
		65444,
		9,
		5444
	],
	"./modules/project/utils/__tests__/projectUtils.test": [
		30524,
		9,
		524
	],
	"./modules/project/utils/__tests__/projectUtils.test.js": [
		30524,
		9,
		524
	],
	"./modules/project/utils/labelListUtils": [
		34034,
		9,
		4034
	],
	"./modules/project/utils/labelListUtils.js": [
		34034,
		9,
		4034
	],
	"./modules/project/utils/projectUtils": [
		21540,
		9,
		1540
	],
	"./modules/project/utils/projectUtils.js": [
		21540,
		9,
		1540
	],
	"./modules/projects": [
		60186,
		9,
		186
	],
	"./modules/projects/": [
		60186,
		9,
		186
	],
	"./modules/projects/actions/__tests__/projectsActions.test": [
		28814,
		9,
		8814
	],
	"./modules/projects/actions/__tests__/projectsActions.test.js": [
		28814,
		9,
		8814
	],
	"./modules/projects/actions/projectsActions": [
		61762,
		9,
		1762
	],
	"./modules/projects/actions/projectsActions.js": [
		61762,
		9,
		1762
	],
	"./modules/projects/components/HomePage": [
		89771,
		9,
		2641,
		2659,
		2304,
		1819,
		4363
	],
	"./modules/projects/components/HomePage.js": [
		89771,
		9,
		2641,
		2659,
		2304,
		1819,
		4363
	],
	"./modules/projects/components/ProjectsPage": [
		41813,
		9,
		1813
	],
	"./modules/projects/components/ProjectsPage.js": [
		41813,
		9,
		1813
	],
	"./modules/projects/components/__styles__/GuideStepPage.styles": [
		74897,
		9,
		4897
	],
	"./modules/projects/components/__styles__/GuideStepPage.styles.js": [
		74897,
		9,
		4897
	],
	"./modules/projects/components/__styles__/HomePage.styles": [
		12511,
		9,
		2511
	],
	"./modules/projects/components/__styles__/HomePage.styles.js": [
		12511,
		9,
		2511
	],
	"./modules/projects/components/__styles__/ProjectsPage.styles": [
		13427,
		9,
		3427
	],
	"./modules/projects/components/__styles__/ProjectsPage.styles.js": [
		13427,
		9,
		3427
	],
	"./modules/projects/components/__tests__/HomePage.test": [
		15270,
		9,
		8693,
		9607,
		2641,
		2659,
		2304,
		1819,
		5933
	],
	"./modules/projects/components/__tests__/HomePage.test.js": [
		15270,
		9,
		8693,
		9607,
		2641,
		2659,
		2304,
		1819,
		5933
	],
	"./modules/projects/components/__tests__/ProjectsPage.test": [
		75950,
		9,
		8693,
		9607,
		5950
	],
	"./modules/projects/components/__tests__/ProjectsPage.test.js": [
		75950,
		9,
		8693,
		9607,
		5950
	],
	"./modules/projects/components/__tests__/__snapshots__/HomePage.test.js.snap": [
		36342,
		1,
		6342
	],
	"./modules/projects/components/__tests__/__snapshots__/ProjectsPage.test.js.snap": [
		20409,
		1,
		409
	],
	"./modules/projects/index": [
		60186,
		9,
		186
	],
	"./modules/projects/index.js": [
		60186,
		9,
		186
	],
	"./modules/projects/reducers/__tests__/projectsReducer.test": [
		90250,
		9,
		250
	],
	"./modules/projects/reducers/__tests__/projectsReducer.test.js": [
		90250,
		9,
		250
	],
	"./modules/projects/reducers/projectsReducer": [
		82082,
		9,
		2082
	],
	"./modules/projects/reducers/projectsReducer.js": [
		82082,
		9,
		2082
	],
	"./modules/projects/sagas/__tests__/projectsSagas.test": [
		56592,
		9,
		2843,
		7594
	],
	"./modules/projects/sagas/__tests__/projectsSagas.test.js": [
		56592,
		9,
		2843,
		7594
	],
	"./modules/projects/sagas/projectsSagas": [
		97109,
		9,
		7109
	],
	"./modules/projects/sagas/projectsSagas.js": [
		97109,
		9,
		7109
	],
	"./modules/projects/selectors/__tests__/projectsSelectors.test": [
		30295,
		9,
		295
	],
	"./modules/projects/selectors/__tests__/projectsSelectors.test.js": [
		30295,
		9,
		295
	],
	"./modules/projects/selectors/projectsSelectors": [
		26583,
		9,
		6583
	],
	"./modules/projects/selectors/projectsSelectors.js": [
		26583,
		9,
		6583
	],
	"./modules/root": [
		28165,
		9
	],
	"./modules/root/": [
		28165,
		9
	],
	"./modules/root/actions/__tests__/rootActions.test": [
		94390,
		9,
		4390
	],
	"./modules/root/actions/__tests__/rootActions.test.js": [
		94390,
		9,
		4390
	],
	"./modules/root/actions/authActions": [
		56814,
		9
	],
	"./modules/root/actions/authActions.js": [
		56814,
		9
	],
	"./modules/root/actions/rootActions": [
		43135,
		9
	],
	"./modules/root/actions/rootActions.js": [
		43135,
		9
	],
	"./modules/root/index": [
		28165,
		9
	],
	"./modules/root/index.js": [
		28165,
		9
	],
	"./modules/root/reducers/__tests__/rootReducer.test": [
		90235,
		9,
		235
	],
	"./modules/root/reducers/__tests__/rootReducer.test.js": [
		90235,
		9,
		235
	],
	"./modules/root/reducers/authReducer": [
		20209,
		9
	],
	"./modules/root/reducers/authReducer.js": [
		20209,
		9
	],
	"./modules/root/reducers/rootReducer": [
		1277,
		9
	],
	"./modules/root/reducers/rootReducer.js": [
		1277,
		9
	],
	"./modules/root/sagas/__tests__/authSaga.test": [
		6220,
		9,
		2843,
		1201
	],
	"./modules/root/sagas/__tests__/authSaga.test.js": [
		6220,
		9,
		2843,
		1201
	],
	"./modules/root/sagas/__tests__/rootSaga.test": [
		30109,
		9,
		2843,
		8169
	],
	"./modules/root/sagas/__tests__/rootSaga.test.js": [
		30109,
		9,
		2843,
		8169
	],
	"./modules/root/sagas/authSaga": [
		12622,
		9
	],
	"./modules/root/sagas/authSaga.js": [
		12622,
		9
	],
	"./modules/root/sagas/rootSaga": [
		38197,
		9
	],
	"./modules/root/sagas/rootSaga.js": [
		38197,
		9
	],
	"./modules/root/selectors/__tests__/authSelectors.test": [
		21589,
		9,
		1589
	],
	"./modules/root/selectors/__tests__/authSelectors.test.js": [
		21589,
		9,
		1589
	],
	"./modules/root/selectors/__tests__/rootSelectors.test": [
		54040,
		9,
		4040
	],
	"./modules/root/selectors/__tests__/rootSelectors.test.js": [
		54040,
		9,
		4040
	],
	"./modules/root/selectors/authSelectors": [
		38659,
		9
	],
	"./modules/root/selectors/authSelectors.js": [
		38659,
		9
	],
	"./modules/root/selectors/rootSelectors": [
		95266,
		9
	],
	"./modules/root/selectors/rootSelectors.js": [
		95266,
		9
	],
	"./modules/root/services/__tests__/authServices.test": [
		5114,
		9,
		5114
	],
	"./modules/root/services/__tests__/authServices.test.js": [
		5114,
		9,
		5114
	],
	"./modules/root/services/__tests__/rootServices.test": [
		47556,
		9,
		7556
	],
	"./modules/root/services/__tests__/rootServices.test.js": [
		47556,
		9,
		7556
	],
	"./modules/root/services/authServices": [
		30147,
		9
	],
	"./modules/root/services/authServices.js": [
		30147,
		9
	],
	"./modules/root/services/rootServices": [
		81511,
		9,
		1511
	],
	"./modules/root/services/rootServices.js": [
		81511,
		9,
		1511
	],
	"./setupTests": [
		79511,
		9,
		2843,
		5708
	],
	"./setupTests.js": [
		79511,
		9,
		2843,
		5708
	],
	"./setupTestsLocal": [
		50578,
		7,
		578
	],
	"./setupTestsLocal.js": [
		50578,
		7,
		578
	],
	"./shared/actions/__tests__/apiActions.test": [
		41724,
		9,
		1724
	],
	"./shared/actions/__tests__/apiActions.test.js": [
		41724,
		9,
		1724
	],
	"./shared/actions/__tests__/i18nActions.test": [
		88135,
		9,
		8135
	],
	"./shared/actions/__tests__/i18nActions.test.js": [
		88135,
		9,
		8135
	],
	"./shared/actions/__tests__/logsActions.test": [
		18031,
		9,
		8031
	],
	"./shared/actions/__tests__/logsActions.test.js": [
		18031,
		9,
		8031
	],
	"./shared/actions/__tests__/storageActions.test": [
		76568,
		9,
		6568
	],
	"./shared/actions/__tests__/storageActions.test.js": [
		76568,
		9,
		6568
	],
	"./shared/actions/apiActions": [
		25411,
		9
	],
	"./shared/actions/apiActions.js": [
		25411,
		9
	],
	"./shared/actions/i18nActions": [
		37157,
		9
	],
	"./shared/actions/i18nActions.js": [
		37157,
		9
	],
	"./shared/actions/logsActions": [
		55171,
		9
	],
	"./shared/actions/logsActions.js": [
		55171,
		9
	],
	"./shared/actions/storageActions": [
		74707,
		9
	],
	"./shared/actions/storageActions.js": [
		74707,
		9
	],
	"./shared/components/Root": [
		83698,
		9
	],
	"./shared/components/Root.js": [
		83698,
		9
	],
	"./shared/components/__tests__/Root.test": [
		35451,
		9,
		8693,
		9607,
		5451
	],
	"./shared/components/__tests__/Root.test.js": [
		35451,
		9,
		8693,
		9607,
		5451
	],
	"./shared/components/__tests__/__snapshots__/Root.test.js.snap": [
		62571,
		1,
		2571
	],
	"./shared/components/app/App": [
		60598,
		9
	],
	"./shared/components/app/App.js": [
		60598,
		9
	],
	"./shared/components/app/Main": [
		62301,
		9
	],
	"./shared/components/app/Main.js": [
		62301,
		9
	],
	"./shared/components/app/__styles__/App.styles": [
		61362,
		9
	],
	"./shared/components/app/__styles__/App.styles.js": [
		61362,
		9
	],
	"./shared/components/app/__styles__/Main.styles": [
		3035,
		9
	],
	"./shared/components/app/__styles__/Main.styles.js": [
		3035,
		9
	],
	"./shared/components/app/__tests__/App.test": [
		2927,
		9,
		8693,
		9607,
		2927
	],
	"./shared/components/app/__tests__/App.test.js": [
		2927,
		9,
		8693,
		9607,
		2927
	],
	"./shared/components/app/__tests__/__snapshots__/App.test.js.snap": [
		98560,
		1,
		8560
	],
	"./shared/components/card/Card": [
		49597,
		9,
		48,
		9597
	],
	"./shared/components/card/Card.js": [
		49597,
		9,
		48,
		9597
	],
	"./shared/components/card/__styles__/Card.styles": [
		17234,
		9,
		48,
		7234
	],
	"./shared/components/card/__styles__/Card.styles.js": [
		17234,
		9,
		48,
		7234
	],
	"./shared/components/card/__tests__/Card.test": [
		25758,
		9,
		8693,
		9607,
		48,
		5758
	],
	"./shared/components/card/__tests__/Card.test.js": [
		25758,
		9,
		8693,
		9607,
		48,
		5758
	],
	"./shared/components/card/__tests__/__snapshots__/Card.test.js.snap": [
		81392,
		1,
		1392
	],
	"./shared/components/common/JsonEditor": [
		17155,
		9,
		8621,
		5652
	],
	"./shared/components/common/JsonEditor.js": [
		17155,
		9,
		8621,
		5652
	],
	"./shared/components/common/__tests__/JsonEditor.test": [
		52009,
		9,
		8693,
		9607,
		8621,
		2763
	],
	"./shared/components/common/__tests__/JsonEditor.test.js": [
		52009,
		9,
		8693,
		9607,
		8621,
		2763
	],
	"./shared/components/common/__tests__/__snapshots__/JsonEditor.test.js.snap": [
		3210,
		1,
		3210
	],
	"./shared/components/error/ErrorBoundary": [
		43926,
		9
	],
	"./shared/components/error/ErrorBoundary.js": [
		43926,
		9
	],
	"./shared/components/error/__tests__/ErrorBoundary.test": [
		89887,
		9,
		8693,
		9607,
		9887
	],
	"./shared/components/error/__tests__/ErrorBoundary.test.js": [
		89887,
		9,
		8693,
		9607,
		9887
	],
	"./shared/components/error/__tests__/__snapshots__/ErrorBoundary.test.js.snap": [
		30261,
		1,
		261
	],
	"./shared/components/grid/Col": [
		22381,
		9,
		5173,
		2381
	],
	"./shared/components/grid/Col.js": [
		22381,
		9,
		5173,
		2381
	],
	"./shared/components/grid/Row": [
		51025,
		9,
		5173,
		1025
	],
	"./shared/components/grid/Row.js": [
		51025,
		9,
		5173,
		1025
	],
	"./shared/components/grid/__styles__/Col.styles": [
		62053,
		9,
		5173,
		2053
	],
	"./shared/components/grid/__styles__/Col.styles.js": [
		62053,
		9,
		5173,
		2053
	],
	"./shared/components/grid/__styles__/Row.styles": [
		94931,
		9,
		5173,
		4931
	],
	"./shared/components/grid/__styles__/Row.styles.js": [
		94931,
		9,
		5173,
		4931
	],
	"./shared/components/grid/__tests__/Col.test": [
		70909,
		9,
		8693,
		5173,
		9607,
		909
	],
	"./shared/components/grid/__tests__/Col.test.js": [
		70909,
		9,
		8693,
		5173,
		9607,
		909
	],
	"./shared/components/grid/__tests__/Row.test": [
		98180,
		9,
		8693,
		5173,
		9607,
		8180
	],
	"./shared/components/grid/__tests__/Row.test.js": [
		98180,
		9,
		8693,
		5173,
		9607,
		8180
	],
	"./shared/components/grid/__tests__/__snapshots__/Col.test.js.snap": [
		67396,
		1,
		7396
	],
	"./shared/components/grid/__tests__/__snapshots__/Row.test.js.snap": [
		29500,
		1,
		9500
	],
	"./shared/components/hotkey/Hotkey": [
		43597,
		9,
		3597
	],
	"./shared/components/hotkey/Hotkey.js": [
		43597,
		9,
		3597
	],
	"./shared/components/hotkey/__styles__/Hotkey.styles": [
		58330,
		9,
		8330
	],
	"./shared/components/hotkey/__styles__/Hotkey.styles.js": [
		58330,
		9,
		8330
	],
	"./shared/components/hotkey/__tests__/Hotkey.test": [
		82316,
		9,
		8693,
		9607,
		2316
	],
	"./shared/components/hotkey/__tests__/Hotkey.test.js": [
		82316,
		9,
		8693,
		9607,
		2316
	],
	"./shared/components/hotkey/__tests__/__snapshots__/Hotkey.test.js.snap": [
		79007,
		1,
		9007
	],
	"./shared/components/loader/Loader": [
		87818,
		9
	],
	"./shared/components/loader/Loader.js": [
		87818,
		9
	],
	"./shared/components/loader/__styles__/Loader.styles": [
		65462,
		9
	],
	"./shared/components/loader/__styles__/Loader.styles.js": [
		65462,
		9
	],
	"./shared/components/loader/__tests__/Loader.test": [
		1926,
		9,
		8693,
		9607,
		1926
	],
	"./shared/components/loader/__tests__/Loader.test.js": [
		1926,
		9,
		8693,
		9607,
		1926
	],
	"./shared/components/loader/__tests__/__snapshots__/Loader.test.js.snap": [
		54404,
		1,
		4404
	],
	"./shared/components/page/Page": [
		4742,
		9,
		4742
	],
	"./shared/components/page/Page.js": [
		4742,
		9,
		4742
	],
	"./shared/components/page/__styles__/Page.styles": [
		55007,
		9,
		5007
	],
	"./shared/components/page/__styles__/Page.styles.js": [
		55007,
		9,
		5007
	],
	"./shared/components/page/__tests__/Page.test": [
		6528,
		9,
		8693,
		9607,
		6528
	],
	"./shared/components/page/__tests__/Page.test.js": [
		6528,
		9,
		8693,
		9607,
		6528
	],
	"./shared/components/page/__tests__/__snapshots__/Page.test.js.snap": [
		80601,
		1,
		601
	],
	"./shared/components/result/Result": [
		28300,
		9
	],
	"./shared/components/result/Result.js": [
		28300,
		9
	],
	"./shared/components/result/__styles__/Result.styles": [
		47246,
		9
	],
	"./shared/components/result/__styles__/Result.styles.js": [
		47246,
		9
	],
	"./shared/components/table/EllipsisTableTooltip": [
		3827,
		9,
		2641,
		2659,
		2304,
		1819,
		8244
	],
	"./shared/components/table/EllipsisTableTooltip.js": [
		3827,
		9,
		2641,
		2659,
		2304,
		1819,
		8244
	],
	"./shared/components/table/Table": [
		55855,
		9,
		2641,
		2659,
		2304,
		1819,
		3227
	],
	"./shared/components/table/Table.js": [
		55855,
		9,
		2641,
		2659,
		2304,
		1819,
		3227
	],
	"./shared/components/table/__styles__/Table.styles": [
		93065,
		9,
		2641,
		2659,
		2304,
		1819,
		2116
	],
	"./shared/components/table/__styles__/Table.styles.js": [
		93065,
		9,
		2641,
		2659,
		2304,
		1819,
		2116
	],
	"./shared/components/table/__tests__/Table.test": [
		50275,
		9,
		8693,
		9607,
		2641,
		2659,
		2304,
		1819,
		1206
	],
	"./shared/components/table/__tests__/Table.test.js": [
		50275,
		9,
		8693,
		9607,
		2641,
		2659,
		2304,
		1819,
		1206
	],
	"./shared/components/table/__tests__/__snapshots__/Table.test.js.snap": [
		1587,
		1,
		1587
	],
	"./shared/components/warning/WarningMessage": [
		32035,
		9,
		2035
	],
	"./shared/components/warning/WarningMessage.js": [
		32035,
		9,
		2035
	],
	"./shared/components/warning/__styles__/WarningMessage.styles": [
		32338,
		9,
		2338
	],
	"./shared/components/warning/__styles__/WarningMessage.styles.js": [
		32338,
		9,
		2338
	],
	"./shared/components/warning/__tests__/WarningMessage.test": [
		33446,
		9,
		8693,
		9607,
		3446
	],
	"./shared/components/warning/__tests__/WarningMessage.test.js": [
		33446,
		9,
		8693,
		9607,
		3446
	],
	"./shared/components/warning/__tests__/__snapshots__/WarningMessage.test.js.snap": [
		63714,
		1,
		3714
	],
	"./shared/enums/annotationTypes": [
		67489,
		9,
		7489
	],
	"./shared/enums/annotationTypes.js": [
		67489,
		9,
		7489
	],
	"./shared/enums/configurationsProjectPropertiesTypes": [
		56066,
		9,
		6066
	],
	"./shared/enums/configurationsProjectPropertiesTypes.js": [
		56066,
		9,
		6066
	],
	"./shared/enums/exportTypes": [
		61260,
		9,
		1260
	],
	"./shared/enums/exportTypes.js": [
		61260,
		9,
		1260
	],
	"./shared/enums/fieldTypes": [
		64942,
		9,
		4942
	],
	"./shared/enums/fieldTypes.js": [
		64942,
		9,
		4942
	],
	"./shared/enums/itemTypes": [
		65033,
		9,
		5033
	],
	"./shared/enums/itemTypes.js": [
		65033,
		9,
		5033
	],
	"./shared/enums/logTabsTypes": [
		33681,
		9,
		3681
	],
	"./shared/enums/logTabsTypes.js": [
		33681,
		9,
		3681
	],
	"./shared/enums/logsTypes": [
		49917,
		9,
		9917
	],
	"./shared/enums/logsTypes.js": [
		49917,
		9,
		9917
	],
	"./shared/enums/markerTypes": [
		31673,
		9,
		1673
	],
	"./shared/enums/markerTypes.js": [
		31673,
		9,
		1673
	],
	"./shared/enums/operatorTypes": [
		54081,
		9,
		4081
	],
	"./shared/enums/operatorTypes.js": [
		54081,
		9,
		4081
	],
	"./shared/enums/paginationTypes": [
		99144,
		9
	],
	"./shared/enums/paginationTypes.js": [
		99144,
		9
	],
	"./shared/enums/privilegesTypes": [
		6700,
		9
	],
	"./shared/enums/privilegesTypes.js": [
		6700,
		9
	],
	"./shared/enums/projectStatsTypes": [
		46318,
		9,
		6318
	],
	"./shared/enums/projectStatsTypes.js": [
		46318,
		9,
		6318
	],
	"./shared/enums/projectTypes": [
		67281,
		9,
		7281
	],
	"./shared/enums/projectTypes.js": [
		67281,
		9,
		7281
	],
	"./shared/enums/projectsTypes": [
		96011,
		9,
		6011
	],
	"./shared/enums/projectsTypes.js": [
		96011,
		9,
		6011
	],
	"./shared/enums/rawTypes": [
		51091,
		9,
		1091
	],
	"./shared/enums/rawTypes.js": [
		51091,
		9,
		1091
	],
	"./shared/enums/rolesTypes": [
		95013,
		9
	],
	"./shared/enums/rolesTypes.js": [
		95013,
		9
	],
	"./shared/enums/tagTypes": [
		35192,
		9,
		5192
	],
	"./shared/enums/tagTypes.js": [
		35192,
		9,
		5192
	],
	"./shared/enums/taskTypes": [
		66261,
		9,
		6261
	],
	"./shared/enums/taskTypes.js": [
		66261,
		9,
		6261
	],
	"./shared/enums/valueTypes": [
		63650,
		9,
		3650
	],
	"./shared/enums/valueTypes.js": [
		63650,
		9,
		3650
	],
	"./shared/hooks/__tests__/useOutsideClick.test": [
		52534,
		9,
		8693,
		9607,
		327,
		2534
	],
	"./shared/hooks/__tests__/useOutsideClick.test.js": [
		52534,
		9,
		8693,
		9607,
		327,
		2534
	],
	"./shared/hooks/__tests__/usePrivileges.test": [
		95177,
		9,
		8693,
		327,
		5177
	],
	"./shared/hooks/__tests__/usePrivileges.test.js": [
		95177,
		9,
		8693,
		327,
		5177
	],
	"./shared/hooks/__tests__/useProjectPrivileges.test": [
		35239,
		9,
		8693,
		327,
		5239
	],
	"./shared/hooks/__tests__/useProjectPrivileges.test.js": [
		35239,
		9,
		8693,
		327,
		5239
	],
	"./shared/hooks/useOnceCall": [
		79322,
		9,
		9322
	],
	"./shared/hooks/useOnceCall.js": [
		79322,
		9,
		9322
	],
	"./shared/hooks/useOutsideClick": [
		39849,
		9,
		9849
	],
	"./shared/hooks/useOutsideClick.js": [
		39849,
		9,
		9849
	],
	"./shared/hooks/usePrivileges": [
		53452,
		9
	],
	"./shared/hooks/usePrivileges.js": [
		53452,
		9
	],
	"./shared/hooks/useProjectPrivileges": [
		21047,
		9
	],
	"./shared/hooks/useProjectPrivileges.js": [
		21047,
		9
	],
	"./shared/hooks/useResolvedAnnotationsAndPredictions": [
		48423,
		9,
		8423
	],
	"./shared/hooks/useResolvedAnnotationsAndPredictions.js": [
		48423,
		9,
		8423
	],
	"./shared/hooks/useZoomImage": [
		19441,
		9,
		9441
	],
	"./shared/hooks/useZoomImage.js": [
		19441,
		9,
		9441
	],
	"./shared/sagas": [
		45001,
		9
	],
	"./shared/sagas/": [
		45001,
		9
	],
	"./shared/sagas/__tests__/apiSagas.test": [
		51314,
		9,
		2843,
		5365
	],
	"./shared/sagas/__tests__/apiSagas.test.js": [
		51314,
		9,
		2843,
		5365
	],
	"./shared/sagas/__tests__/i18nSagas.test": [
		72642,
		9,
		2642
	],
	"./shared/sagas/__tests__/i18nSagas.test.js": [
		72642,
		9,
		2642
	],
	"./shared/sagas/__tests__/logsSagas.test": [
		17892,
		9,
		2843,
		1940
	],
	"./shared/sagas/__tests__/logsSagas.test.js": [
		17892,
		9,
		2843,
		1940
	],
	"./shared/sagas/__tests__/storageSagas.test": [
		91314,
		9,
		1314
	],
	"./shared/sagas/__tests__/storageSagas.test.js": [
		91314,
		9,
		1314
	],
	"./shared/sagas/apiSagas": [
		27287,
		9
	],
	"./shared/sagas/apiSagas.js": [
		27287,
		9
	],
	"./shared/sagas/i18nSagas": [
		8849,
		9
	],
	"./shared/sagas/i18nSagas.js": [
		8849,
		9
	],
	"./shared/sagas/index": [
		45001,
		9
	],
	"./shared/sagas/index.js": [
		45001,
		9
	],
	"./shared/sagas/logsSagas": [
		7965,
		9
	],
	"./shared/sagas/logsSagas.js": [
		7965,
		9
	],
	"./shared/sagas/storageSagas": [
		4607,
		9
	],
	"./shared/sagas/storageSagas.js": [
		4607,
		9
	],
	"./shared/services/__tests__/apiService.test": [
		16989,
		9,
		6989
	],
	"./shared/services/__tests__/apiService.test.js": [
		16989,
		9,
		6989
	],
	"./shared/services/__tests__/module": [
		59302,
		3,
		9302
	],
	"./shared/services/__tests__/module.json": [
		59302,
		3,
		9302
	],
	"./shared/services/__tests__/moduleServices.test": [
		87535,
		9,
		7535
	],
	"./shared/services/__tests__/moduleServices.test.js": [
		87535,
		9,
		7535
	],
	"./shared/services/__tests__/storageServices.test": [
		8105,
		9,
		8105
	],
	"./shared/services/__tests__/storageServices.test.js": [
		8105,
		9,
		8105
	],
	"./shared/services/apiServices": [
		57628,
		9
	],
	"./shared/services/apiServices.js": [
		57628,
		9
	],
	"./shared/services/moduleServices": [
		50698,
		9
	],
	"./shared/services/moduleServices.js": [
		50698,
		9
	],
	"./shared/services/storageServices": [
		17348,
		9
	],
	"./shared/services/storageServices.js": [
		17348,
		9
	],
	"./shared/utils/__tests__/annotationUtils.test": [
		61461,
		9,
		1461
	],
	"./shared/utils/__tests__/annotationUtils.test.js": [
		61461,
		9,
		1461
	],
	"./shared/utils/__tests__/classificationsUtils.test": [
		34207,
		9,
		4207
	],
	"./shared/utils/__tests__/classificationsUtils.test.js": [
		34207,
		9,
		4207
	],
	"./shared/utils/__tests__/dateUtils.test": [
		94960,
		9,
		4960
	],
	"./shared/utils/__tests__/dateUtils.test.js": [
		94960,
		9,
		4960
	],
	"./shared/utils/__tests__/filterUtils.test": [
		8468,
		9,
		8468
	],
	"./shared/utils/__tests__/filterUtils.test.js": [
		8468,
		9,
		8468
	],
	"./shared/utils/__tests__/htmlUtils.test": [
		7759,
		9,
		8703,
		7759
	],
	"./shared/utils/__tests__/htmlUtils.test.js": [
		7759,
		9,
		8703,
		7759
	],
	"./shared/utils/__tests__/jsonUtils.test": [
		19590,
		9,
		9590
	],
	"./shared/utils/__tests__/jsonUtils.test.js": [
		19590,
		9,
		9590
	],
	"./shared/utils/__tests__/urlUtils.test": [
		84765,
		9,
		4765
	],
	"./shared/utils/__tests__/urlUtils.test.js": [
		84765,
		9,
		4765
	],
	"./shared/utils/annotationUtils": [
		48821,
		9,
		8821
	],
	"./shared/utils/annotationUtils.js": [
		48821,
		9,
		8821
	],
	"./shared/utils/dateUtils": [
		74876,
		9,
		4876
	],
	"./shared/utils/dateUtils.js": [
		74876,
		9,
		4876
	],
	"./shared/utils/filterUtils": [
		40445,
		9,
		445
	],
	"./shared/utils/filterUtils.js": [
		40445,
		9,
		445
	],
	"./shared/utils/htmlUtils": [
		43564,
		9,
		8703,
		3564
	],
	"./shared/utils/htmlUtils.js": [
		43564,
		9,
		8703,
		3564
	],
	"./shared/utils/jsonUtils": [
		70905,
		9,
		905
	],
	"./shared/utils/jsonUtils.js": [
		70905,
		9,
		905
	],
	"./shared/utils/tasksUtils": [
		67121,
		9,
		7121
	],
	"./shared/utils/tasksUtils.js": [
		67121,
		9,
		7121
	],
	"./shared/utils/urlUtils": [
		10072,
		9
	],
	"./shared/utils/urlUtils.js": [
		10072,
		9
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, ids[1] | 16)
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 85323;
module.exports = webpackAsyncContext;